import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Mapbox from "mapbox-gl-vue"
import VueResource from "vue-resource"
import axios from 'axios'
import auth from './services/auth'
import store from './store/index'

require('../icons/favicon.ico')

Vue.component("mapbox", Mapbox)
Vue.use(VueResource)
Vue.use(Vuetify, { theme: {
  primary: '#3675cc',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}})

Vue.config.productionTip = false
axios.interceptors.request.use(auth.requestInterceptor);
axios.interceptors.response.use(x => x, auth.responseErrorInterceptor);

mapboxgl.accessToken = "pk.eyJ1IjoibmFycm93dHV4IiwiYSI6ImNpZnRnbzVzNDAxdnd0a20wdG91ZHphOWcifQ.o13TzVvrJVe2J_WriuuEIw"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js